export const size = {
  sm: "480px",
  md: "768px",
  lg: "1024px",
  xl: "1920px",
};

export const device = {
  sm: `(max-width: ${size.md})`,
  md: `(min-width: ${size.md}) and (max-width: ${size.lg})`,
  lg: `(min-width: ${size.lg}) and (max-width: ${size.xl})`,
  xl: `(min-width: ${size.xl})`,
  mobilePortrait: `(max-width: ${size.md}) and (orientation: portrait)`,
  tabletPortrait: `(max-width: ${size.lg}) and (orientation: portrait)`,
  mobileLandscape: `(max-width: ${size.lg}) and (orientation: landscape)`,
};
